import React from 'react';

import { connect } from 'react-redux';

import { Box } from '@nerdwallet/currency';
import { Tracking } from '@nerdwallet/nw-client-lib';

import { zoom, zoomActions } from '../../../../lib/actions';
import { MCBreakdown, MCResultsHeader, MCMonthlyResults } from '../index';
import type { MortgageCalculators } from '../types';

// Constants
const SECTION_NAMES = [
  'Monthly payment',
  'Amortization',
  'Compare common loan types',
  'Compare loan details',
];

interface MCResultsPanelProps {
  dispatch: (action: any) => any;
  trackingFormName: 'mc-results' | 'mpc-results';
  mortgageCalculator: MortgageCalculators;
}

const MCResultsPanel = ({
  mortgageCalculator,
  dispatch,
  trackingFormName,
}: MCResultsPanelProps): JSX.Element => {
  const trackResultsSection = (fieldValue: string | number) => {
    // Track which section was opened.
    Tracking.formOpen({
      formName: trackingFormName,
      fieldName: 'results-section',
      fieldValue,
    });
  };

  const onSectionEnter = (index: number) => {
    const shouldZoomIn = index > 0;
    trackResultsSection(SECTION_NAMES[index]);

    // Dispatch an action to zoom in or out.
    dispatch(zoom(shouldZoomIn ? zoomActions.ZOOM_IN : zoomActions.ZOOM_OUT));
  };

  return (
    <Box>
      <MCResultsHeader mortgageCalculator={mortgageCalculator} />
      <MCMonthlyResults mortgageCalculator={mortgageCalculator} />
      <MCBreakdown
        onSectionEnter={onSectionEnter}
        trackingFormName={trackingFormName}
        mortgageCalculator={mortgageCalculator}
      />
    </Box>
  );
};

MCResultsPanel.displayName = 'MCResultsPanel';

// I only need dispatch ¯\_(ツ)_/¯ we need hooks!
export default connect()(MCResultsPanel);
